import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { useTheme } from '@mui/material/styles';

const Frame = styled('div')(({
  $topMargin,
  $session,
  $hideComponent,
  theme,
  $borderColor,
}) => {
  const displayLogic =
    $hideComponent === 'session'
      ? $session
        ? 'none'
        : 'flex'
      : $hideComponent === 'nosession'
        ? !$session
          ? 'none'
          : 'flex'
        : 'flex';

  const borderColor =
    $borderColor === '#000'
      ? '#000'
      : (theme.palette.grey[$borderColor] ?? '#000');

  return {
    width: '100%',
    margin: `0 0 ${$topMargin} 0`,
    '@media screen and (max-width: 899px)': {
      display: 'none',
    },
    '@media screen and (min-width: 900px)': {
      display: displayLogic,
      borderBottom: `1px solid ${borderColor}`,
    },
  };
});

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  [theme.breakpoints.up('md')]: {
    padding: '10px',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const Breadcrumb = styled('span')(({ theme, color }) => ({
  display: 'inline',
  fontSize: '0.875rem',
  lineHeight: '1.125rem',
  textTransform: 'uppercase',
  color: theme.palette.text[color],
  variants: [
    {
      props: {
        color: 'default',
      },
      style: {
        color: theme.palette.primary.dark,
      },
    },
  ],
}));

const BreadcrumbTrail = ({ module, topMargin = '20px' }) => {
  const { fields } = module;
  const { data: session } = useSession();
  const theme = useTheme();

  return (
    <Frame
      $topMargin={topMargin}
      $session={session}
      $hideComponent={fields.hideComponent}
      $borderColor={fields.borderColor}
    >
      <Box
        sx={{
          width: '100%',
          ml: 'auto',
          mr: 'auto',
          maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
        }}
      >
        <Container>
          {fields.breadcrumbList &&
            fields.breadcrumbList.length > 0 &&
            fields.breadcrumbList
              .sort((a, b) => {
                if (parseInt(a.fields.order, 10) > parseInt(b.fields.order, 10))
                  return 1;
                if (parseInt(a.fields.order, 10) < parseInt(b.fields.order, 10))
                  return -1;
                return 0;
              })
              .map((breadcrumb, _index) => {
                return (
                  <Breadcrumb
                    key={breadcrumb.contentID}
                    color={fields.textColor ?? 'default'}
                  >
                    {breadcrumb.fields.breadcrumbUrl.href &&
                    breadcrumb.fields.breadcrumbUrl.href.length > 0 ? (
                      <Link
                        href={breadcrumb.fields.breadcrumbUrl.href}
                        target={breadcrumb.fields.breadcrumbUrl.target}
                        rel="noopener noreferrer"
                      >
                        {breadcrumb.fields.breadcrumbUrl.text}
                      </Link>
                    ) : (
                      <span>{breadcrumb.fields.breadcrumbUrl.text}</span>
                    )}
                    {breadcrumb.fields.breadcrumbUrl.href &&
                      breadcrumb.fields.breadcrumbUrl.href.length > 0 && (
                        <span>{' / '}&nbsp;</span>
                      )}
                  </Breadcrumb>
                );
              })}
        </Container>
      </Box>
    </Frame>
  );
};
export default BreadcrumbTrail;
